$(document).ready(function(){
  
  // Preloading elements
  setTimeout(function(){
    $('.Sticky_announcment_bar_text').addClass('loaded');
  },300);

  // Stackable discount app

  if (window.location.href.indexOf("#openSckbl") != -1) {
    setTimeout(function(){
      $('.stkbl-promo-button').trigger('click');
      console.log('Stackble open');
    },2000);
  }
  if (window.location.href.indexOf("royal-nero-bandeu-bikini-top-free") != -1) {
    window.location.replace('https://makarawear.com/products/royal-nero-bandeu-bikini-top-1');
  }

  // Email free gift
  if (window.location.href.indexOf("#FreeGift") != -1) {
    var giftId = 40149054390330;
    var giftProductId = 7141462212666;
    var gift_in_cart = 0;
    var gift_product_in_cart = 0;
    jQuery.getJSON('/cart.js', function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          gift_in_cart += cart.items[i].quantity;
        }
        if (cart.items[i].product_id == giftProductId) {
          gift_product_in_cart += cart.items[i].quantity;
        }
      }
      if ( gift_product_in_cart < 1){
        if (gift_in_cart == 0 ){
          data = {
            "id": giftId,
            "quantity": 1
          }
  
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log(data);
              buildCart();
              setTimeout(function () {
                $('.Slide_cart_whole').css('right', '0px');
                $('.Slide_cart_overlay').show();
              }, 500);
            }
          });
        }
        else{
          data = {
            "id": giftId,
            "quantity": 1
          }
  
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log(data);
              buildCart();
              setTimeout(function () {
                $('.Slide_cart_whole').css('right', '0px');
                $('.Slide_cart_overlay').show();
              }, 500);
            }
          });
        }
      }
      // console.log(gift_in_cart, 'Gift Id');
    })
  }

  $(document).on("change",".Slide_cart_free_gift_selector__js",function(evt) {
    var lastId = $(this).attr('data-currentId');
    $(this).parent('div').parent('.Slide_cart_item_line').addClass('Loading');
    var currentId = $(this).val();
    data = {
      "id": lastId,
      "quantity": 0
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function () {
        console.log(data);
      }
    });

    // adding New variant
    setTimeout(function(){
      data = {
        "id": currentId,
        "quantity": 1
      }
  
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
          buildCart();
          $('.Slide_cart_item_line').removeClass('Loading');
        }
      });
    },1000);
    
    
  });

  // Adding to cart integration
  $(document).on("click",".button--add-to-cart",function(evt) {
    evt.preventDefault;
    setTimeout(function(){
      buildCart();
    },500);
    setTimeout(function () {
      $('.Slide_cart_whole').css('right', '0px');
      $('.Slide_cart_overlay').show();
      $('#reamaze-widget').hide();
    }, 1500);
  });

  

  

  $('.Slide_cart_upsells_slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      });

      function freeGiftFromOffer() {
        jQuery.getJSON("/cart.js", function (cart) {
          if (cart.item_count >= 1) {
            var giftId = 40149054390330;
            var giftId2 = 40149054423098;
            var giftId3 = 40149054455866;
            var giftProductId = 7141462212666;
            var giftQty = 0;
            var giftQty2 = 0;
            var giftQty3 = 0;
            var giftProductQty = 0;
            var notGiftProduct = 0;
            var changing = 'zero';
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].id == giftId) {
                giftQty += cart.items[i].quantity;
              }
              if (cart.items[i].id == giftId2) {
                giftQty2 += cart.items[i].quantity;
              }
              if (cart.items[i].id == giftId3) {
                giftQty3 += cart.items[i].quantity;
              }
              if (cart.items[i].product_id == giftProductId) {
                giftProductQty += cart.items[i].quantity;
              }
              else{
                notGiftProduct += cart.items[i].quantity;
              }
            }
            console.log('Not Gift Product in cart', notGiftProduct);
            if (notGiftProduct == 0){
              changing = 'zero';
              if (giftQty > 0){
                var data = {
                  id: giftId,
                  quantity: 0,
                };
              }
              if (giftQty2 > 0){
                var data = {
                  id: giftId2,
                  quantity: 0,
                };
              }
              if (giftQty3 > 0){
                var data = {
                  id: giftId3,
                  quantity: 0,
                };
              }
              
              console.log('Changing1', notGiftProduct);
            }
            else if (notGiftProduct > 0){
              changing = 'one';
              var data = {
                id: giftId,
                quantity: 1,
              };
              console.log('Changing2', notGiftProduct);
            }  
    
            if (giftProductQty > 0) {
              if (giftProductQty > 0 && changing == 'one' && notGiftProduct > 0){
                console.log('Not Changing');
              }
              else{
                console.log('Changing', giftProductQty, changing);
                jQuery.ajax({
                  type: "POST",
                  url: "/cart/change.js",
                  data: data,
                  dataType: "json",
                  success: function () {
                    console.log("Changed Gift Quantity");
                  },
                });
              }
            } else {
              jQuery.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: data,
                dataType: "json",
                success: function () {
                  console.log("Added Gift Quantity");
                },
              });
            }
          }
        });
      }
    
    function buildCart() {
      // freeGiftFromOffer();
      // Checking for customized products optional product

        setTimeout(function () {
          var cart_item = [];
          jQuery.getJSON('/cart.js', function (cart) {


            function isSale50Enabled() {
              var cookies = document.cookie.split(';');
              for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.indexOf('sale50Applied=enabledeee') === 0) {
                  return true;
                }
              }
              return false;
            }
      
            console.log(cart);
            // Free shipping calculation
            var total_price_int = cart.total_price / 100;
            var price_before_free_shipping = 0;
            var compare_price_integer;
            // console.log(total_price_int);
            if (total_price_int < 300.00) {
              price_before_free_shipping = (300.00 - total_price_int).toFixed(2);
              $('.Slide_cart_announcment_message').html('You’re <span>$' + price_before_free_shipping + '</span> away from <span>FREE</span> shipping!');
              // var multiplier = 0.015;
              // var progress_bar_percentage = 200 - (multiplier * price_before_free_shipping * 100);
              progress_bar_percentage = 100 * total_price_int / 300;
              progress_bar_percentage = Math.floor(progress_bar_percentage);
              console.log(progress_bar_percentage, price_before_free_shipping);
              $('.Slide_cart_progress_bar_inner').css('width', progress_bar_percentage + '%');
            }
            else {
              $('.Slide_cart_announcment_message').html('You’ve unlocked <strong>FREE</strong> shipping!');
              $('.Slide_cart_progress_bar_inner').css('width', '100%');
            }

            console.log(cart);
            if (isSale50Enabled()) {
              var total_price = (cart.total_price * 0.5 / 100).toFixed(2);
            }
            else{
              var total_price = (cart.total_price / 100).toFixed(2);
            }
            var compare_price_total = 0;
            var sale_product_in_cart = 0;
            $('.Slide_cart_upsells_slider').slick('slickUnfilter');
            $('.Slide_cart_upsells_slider .slick-slide').addClass('NotInCart');

            // Checking if bundle is in cart
            // ============== ADDING UP ALL BUNDLE ITEMS ============ 
            var surferBabe = 0;
            var oceanLover = 0;
            var vintageClassic = 0;
            var vacationMode = 0;
            // Bundle Items checking
            for (var i = 0; i < cart.items.length; i++) {
              $('.All_product_selector__js').each(function(){
                if ($(this).attr('data-bundle') == 'surferBabe'){
                  if (cart.items[i].id == $(this).attr('data-id')){
                    console.log('THIS', cart.items[i].id);
                    surferBabe+=cart.items[i].quantity;
                  }
                }
              });
            }
            for (var i = 0; i < cart.items.length; i++) {
              $('.All_product_selector__js').each(function(){
                if ($(this).attr('data-bundle') == 'oceanLover'){
                  if (cart.items[i].id == $(this).attr('data-id')){
                    console.log('THIS', cart.items[i].id);
                    oceanLover+=cart.items[i].quantity;
                  }
                }
              });
            }
            for (var i = 0; i < cart.items.length; i++) {
              $('.All_product_selector__js').each(function(){
                if ($(this).attr('data-bundle') == 'vintageClassic'){
                  if (cart.items[i].id == $(this).attr('data-id')){
                    console.log('THIS', cart.items[i].id);
                    vintageClassic+=cart.items[i].quantity;
                  }
                }
              });
            }
            for (var i = 0; i < cart.items.length; i++) {
              $('.All_product_selector__js').each(function(){
                if ($(this).attr('data-bundle') == 'vacationMode'){
                  if (cart.items[i].id == $(this).attr('data-id')){
                    console.log('THIS', cart.items[i].id);
                    vacationMode+=cart.items[i].quantity;
                  }
                }
              });
            }
            console.log(surferBabe, 'SURFER BABE COLLECTION ITEMS');
            console.log(oceanLover, 'OCEAN LOVER COLLECTION ITEMS');
            console.log(vacationMode, 'VACATION MODE COLLECTION ITEMS');
            console.log(vintageClassic, 'VINTAGE CLASSIC COLLECTION ITEMS');
      
            for (var i = 0; i < cart.items.length; i++) {
              var quantity = cart.items[i].quantity;
              if (isSale50Enabled()) {
                var price = (cart.items[i].price * 0.5 * quantity / 100).toFixed(2);
              } else {
                var price = (cart.items[i].price * quantity / 100).toFixed(2);
              }
            //   var currency_trigger = $('.Currency_trigger').attr('val');
            //   var currency = currency_trigger.replace('0,00', '');
            var currency = '$';
            //   console.log(currency, 'Currency Trigger');
            //   var currency = '$';
              var compare_price = '';
      
              // Product check for upsell popups
              if (cart.items[i].handle.indexOf('bio-pod-refill-30-off') != -1 || cart.items[i].handle.indexOf('the-wand-30-pack-35-off') != -1) {
                sale_product_in_cart++;
              }
      
              // Product check for upsells
              $('.Slide_cart_whole_upsell__js').each(function () {
                for (var i = 0; i < cart.items.length; i++) {
                  var data_id = parseFloat($(this).attr('data-id'));
                  // console.log(data_id, cart.items[i].product_id, 'Test');
                  if (data_id == cart.items[i].product_id) {
                    console.log(data_id, cart.items[i].product_id);
                    // $(this).parent('div').parent('.slick-slide').removeClass('NotInCart');
                     console.log('in cart yet');
                  }
                }
              });
      
              // Price check
              $('.All_product_selector__js').each(function () {
                if ($(this).attr('data-id') == cart.items[i].id) {
                  // console.log($(this).attr('data-compare-price'));
                  compare_price = $(this).attr('data-compare-price');
                  // console.log(compare_price, $(this).attr('data-id'));
                }
                else {
                  // compare_price = '0.00';
                }
              });
              compare_price_integer = compare_price * quantity;
              compare_price = (compare_price * quantity / 100).toFixed(2);
              console.log(compare_price, 'compare price');
              var price_integer;
              if (compare_price != '0.00') {
                console.log(cart.items[i].original_price, cart.items[i].final_price, 'price_line');
                if (cart.items[i].final_price == cart.items[i].original_price) {
                  if (isNaN(compare_price)) {
                    var price_line = currency + price + '';
                    var discount_off = 100 - (100 * price / compare_price).toFixed(0);
                    var discount = '';
                  }
                  else {
                    var price_line = currency + price + '<s>' + currency + compare_price + '</s>';
                    var discount_off = 100 - (100 * price / compare_price).toFixed(0);
                    var discount = '<p class="Slide_cart_discount_tab">-' + discount_off + '% OFF</p>';
                    price_integer = quantity * cart.items[i].final_price;
                  }
      
                  // console.log('this');
                }
                else if (cart.items[i].final_price < cart.items[i].original_price) {
                  compare_price = (quantity * cart.items[i].original_price / 100).toFixed(2);
                  compare_price_integer = quantity * cart.items[i].original_price / 100;
                  if (isSale50Enabled()) {
                    price = (quantity * cart.items[i].final_price / 100).toFixed(2);
                  }
                  else{
                    price = (quantity * cart.items[i].final_price / 100).toFixed(2);
                  }
                  var price_line = currency + price + '<s>' + currency + compare_price + '</s>';
                  var discount_off = 100 - (100 * price / compare_price).toFixed(0);
                  var discount = '<p class="Slide_cart_discount_tab">-' + discount_off + '% OFF</p>';
                  price_integer = quantity * cart.items[i].final_price;
      
                }
              }
              else {
                var discount = '';
                if (cart.items[i].final_price == cart.items[i].original_price) {
                  var price_line = currency + price;
                  var discount_off = 100 - (100 * price / compare_price).toFixed(0);
                  var discount = '<p class="Slide_cart_discount_tab"></p>';
                  // console.log('without discount code');
                  price_integer = quantity * cart.items[i].final_price;
      
                }
                else if (cart.items[i].final_price < cart.items[i].original_price) {
                  compare_price = (quantity * cart.items[i].original_price / 100).toFixed(2);
                  compare_price_integer = quantity * cart.items[i].original_price;
                  if (isSale50Enabled()) {
                    price = (quantity * cart.items[i].final_price / 100).toFixed(2);
                  }
                  {
                    price = (quantity * cart.items[i].final_price  / 100).toFixed(2);
                  }
                  var price_line = currency + price + '<s>' + currency + compare_price + '</s>';
                  var discount_off = 100 - (100 * price / compare_price).toFixed(0);
                  var discount = '<p class="Slide_cart_discount_tab">-' + discount_off + '% OFF</p>';
                  price_integer = quantity * cart.items[i].final_price;
      
                }
              }
              if (compare_price_integer == 0) {
                compare_price_total += price_integer;
                // console.log( price_integer, 'price integer');
              }
              else {
                //  console.log(compare_price_total, 'compare price total before');
                compare_price_total += compare_price_integer;
                // console.log(compare_price_total,' ',compare_price_integer, 'compare price integer');
              }
              //  compare_price_total += compare_price_integer;
              //  console.log(compare_price_total, 'compare price total');
      
      
              // Variant Title check
              var variant_title = cart.items[i].variant_title;
              if (variant_title) {
      
              }
              else {
                variant_title = '';
              }
      
              // Bordering cart items
              if (i == 0) {
                var Border_top = ' Top';
              }
              else {
                var Border_top = '';
              }

              // Creating every item
              if (surferBabe > 3 || oceanLover > 3 || vintageClassic > 3 || vacationMode > 5){
                if (cart.items[i].product_id == '7141462212666' ) {
                  if (variant_title == 'S'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054390330">S</option>
                            <option value="40149054423098">M</option>
                            <option value="40149054455866">L</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                  else if (variant_title == 'M'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054423098">M</option>
                            <option value="40149054390330">S</option>
                            <option value="40149054455866">L</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                  else if (variant_title == 'L'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054455866">L</option>
                            <option value="40149054390330">S</option>
                            <option value="40149054423098">M</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                }
                else if (String(cart.items[i].sku).indexOf('Custom') != -1 ) {
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                     <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                     <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                     </div>
                    </div>
                </div>
                    `;
                }
                else if (String(cart.items[i].handle).indexOf('optional') != -1){
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://static.boldcommerce.com/options/swatch/422996/ec5029706e0b98171c8f0be2649d95e3.png">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Selected Chain</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                     <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                      <input type="hidden" class="Slide_cart_bundle_offer_item" data="`+cart.items[i].id+`">
                     </div>
                    </div>
                </div>
                    `;
                }
                // Ocean badge
                else if ( cart.items[i].product_id == '7149907738682' || cart.items[i].product_id == '7150054998074' || cart.items[i].product_id == '7150055161914' || cart.items[i].product_id == '7149941456954' || cart.items[i].product_id == '7149616988218' ){
                  cart_item[i] = `
                  <div class="Slide_cart_item_line SlideCart_item_line_`+cart.items[i].product_id+``+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://cdn.shopify.com/s/files/1/0026/5764/8709/files/OceanLover.jpg?v=1701957381">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Sea Spirit</h1>
                    <p class="Slide_cart_item_variant">Luna Long Sleeve Swimwear</p>
                    <p class="Slide_cart_item_variant">Kamala Sporty Bikini Top</p>
                    <p class="Slide_cart_item_variant">Kamala High Waist String Panties</p>
                    <p class="Slide_cart_item_variant">Round Makara Tote Bag</p>
                    <h1 class="Slide_cart_price">$334.00<s>$250.50</s>
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                    </div>
                  </div>
                </div>
                `;
                }
                // Surfer Babe badge
                else if ( cart.items[i].product_id == '7149907738682' || cart.items[i].product_id == '7149907968058' || cart.items[i].product_id == '1740799901765' || cart.items[i].product_id == '7149616988218' || cart.items[i].product_id == '7151153971258'){
                  cart_item[i] = `
                  <div class="Slide_cart_item_line SlideCart_item_line_`+cart.items[i].product_id+``+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://cdn.shopify.com/s/files/1/0026/5764/8709/files/SurferBabe.jpg?v=1701957344">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Wave Queen</h1>
                    <p class="Slide_cart_item_variant">Luna Long Sleeve Swimwear</p>
                    <p class="Slide_cart_item_variant">Budi Bikini Bottom</p>
                    <p class="Slide_cart_item_variant">Budi Sporty Bikini Top</p>
                    <p class="Slide_cart_item_variant">Round Makara Tote Bag</p>
                    <h1 class="Slide_cart_price">$235.50<s>$314.00</s>
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                    </div>
                  </div>
                </div>
                `;
                }
                // Vintage Classic
                else if ( cart.items[i].product_id == '7149992706106' || cart.items[i].product_id == '7149992378426' || cart.items[i].product_id == '7149991919674' || cart.items[i].product_id == '7149616988218' ){
                  cart_item[i] = `
                  <div class="Slide_cart_item_line SlideCart_item_line_`+cart.items[i].product_id+``+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://cdn.shopify.com/s/files/1/0026/5764/8709/files/VintageClassic.jpg?v=1701957828">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Retro Chic</h1>
                    <p class="Slide_cart_item_variant">Luna Long Sleeve Swimwear</p>
                    <p class="Slide_cart_item_variant">Ex-Libris One Piece Swimsuit</p>
                    <p class="Slide_cart_item_variant">Turtle Neck One Piece Swimsuit</p>
                    <p class="Slide_cart_item_variant">Organic Cotton Long Sleeve Crop Top</p>
                    <h1 class="Slide_cart_price">$320.45<s>$493.00</s>
                    </h1>
                  </div> 
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                    </div>
                  </div>
                </div>
                `;
                }
                // Vacation Mode
                else if ( cart.items[i].product_id == '7150055948346' || cart.items[i].product_id == '7150055817274' || cart.items[i].product_id == '7150055653434' || cart.items[i].product_id == '7150055522362' || cart.items[i].product_id == '7150055161914' || cart.items[i].product_id == '7150054998074' ){
                  cart_item[i] = `
                  <div class="Slide_cart_item_line SlideCart_item_line_`+cart.items[i].product_id+``+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://cdn.shopify.com/s/files/1/0026/5764/8709/files/VacationMode.jpg?v=1701957981">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Vacay Vibes</h1>
                    <p class="Slide_cart_item_variant">Kamala Sporty Bikini Top</p>
                    <p class="Slide_cart_item_variant">Kamala High Waist String Panties</p>
                    <p class="Slide_cart_item_variant">Open Scale One Piece Swimsuit</p>
                    <p class="Slide_cart_item_variant">Jogi High-Waisted Flute Pants</p>
                    <p class="Slide_cart_item_variant">Bagira G-Sleeve Swimsuit</p>
                    <p class="Slide_cart_item_variant">Alila Black Sarong</p>
                    <h1 class="Slide_cart_price">$367.80<s>$613.00</s>
                    </h1>
                  </div> 
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                    </div>
                  </div>
                </div>
                `;
                }
                else {
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_quantity_container">
                      <div class="Slide_cart_quantity_min__Js" data-id="`+ cart.items[i].id + `">-</div>
                      <div class="Slide_cart_quantity_value__Js">`+ quantity + `</div>
                      <div class="Slide_cart_quantity_add__Js" data-id="`+ cart.items[i].id + `">+</div>
                    </div>
                  </div>
                </div>
                    `;
                }
              }
              else{
                if (cart.items[i].product_id == '7141462212666' ) {
                  if (variant_title == 'S'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054390330">S</option>
                            <option value="40149054423098">M</option>
                            <option value="40149054455866">L</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                  else if (variant_title == 'M'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054423098">M</option>
                            <option value="40149054390330">S</option>
                            <option value="40149054455866">L</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                  else if (variant_title == 'L'){
                    cart_item[i] = `
                      <div class="Slide_cart_item_line`+ Border_top + `">
                        <div>
                          <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                        </div>
                        <div>
                          <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                          <p class="Slid_cart_choose_size">Choose your size:</p>
                          <select class="Slide_cart_free_gift_selector__js" data-currentId="`+ cart.items[i].id +`">
                            <option value="40149054455866">L</option>
                            <option value="40149054390330">S</option>
                            <option value="40149054423098">M</option>
                          </select>
                          `+ discount + `
                          <h1 class="Slide_cart_price">`+ price_line + `
                          </h1>
                        </div>
                        <div>
                          <div class="Slide_cart_gift_price_cell">
                          <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                          <p class="Slide_cart_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                          </div>
                          </div>
                      </div>
                        `;
                  }
                }
                else if (String(cart.items[i].sku).indexOf('Custom') != -1 ) {
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_gift_price_cell">
                     <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                     <p class="Slide_cart_bundle_remove_item__js" data-id="`+ cart.items[i].id + `">Remove</p>
                     </div>
                    </div>
                </div>
                    `;
                }
                else if (String(cart.items[i].handle).indexOf('optional') != -1){
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="https://static.boldcommerce.com/options/swatch/422996/ec5029706e0b98171c8f0be2649d95e3.png">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">Selected Chain</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                     <div class="Slide_cart_gift_price_cell">
                      <p class="Slide_cart_gift_quantity">`+ quantity + `</p>
                      <input type="hidden" class="Slide_cart_bundle_offer_item" data="`+cart.items[i].id+`">
                     </div>
                    </div>
                </div>
                    `;
                }
                else {
                  cart_item[i] = `
                <div class="Slide_cart_item_line`+ Border_top + `">
                  <div>
                    <img class="Slide_cart_item_image" src="`+ cart.items[i].image + `">
                  </div>
                  <div>
                    <h1 class="Slide_cart_item_title">`+ cart.items[i].product_title + `</h1>
                    <p class="Slide_cart_item_variant">`+ variant_title + `</p>
                    `+ discount + `
                    <h1 class="Slide_cart_price">`+ price_line + `
                    </h1>
                  </div>
                  <div>
                    <div class="Slide_cart_quantity_container">
                      <div class="Slide_cart_quantity_min__Js" data-id="`+ cart.items[i].id + `">-</div>
                      <div class="Slide_cart_quantity_value__Js">`+ quantity + `</div>
                      <div class="Slide_cart_quantity_add__Js" data-id="`+ cart.items[i].id + `">+</div>
                    </div>
                  </div>
                </div>
                    `;
                }
              }
      
            }
      
            // SLide cart upsells
            // $('.Slide_cart_upsells_slider').slick('slickFilter', '.NotInCart');
            if ($('.Slide_cart_upsells_slider .slick-track').is(':empty')) {
               console.log('Upsell in cart should be empty');
              // $('.Slide_cart_upsells_container_outer').hide();
            }
            else {
              $('.Slide_cart_upsells_container_outer').show();
              $(".Slide_cart_upsells_slider").slick('refresh');
            }
      
      
            // Sale popup checking
            if (sale_product_in_cart == 0) {
              $('.Popup_not_visible__js').attr('data-checkout', 0);
            }
            else {
              $('.Popup_not_visible__js').attr('data-checkout', 1);
            }

            $('.cart-link__bubble').html(cart.item_count);
            if (cart.item_count == 0) {
              $('.header-cart__count').hide();
              $('.Slide_cart_empty_content').show();
              $('.Slide_cart_upsells_title').hide();
              $('.Slide_cart_upsells_slider').css('opacity', '0');
              $('.Slide_cart_icons').hide();
              $('.Slide_cart_content_products').html(cart_item);
              $('.Slide_cart_title').find('span').text('• ' + cart.item_count + ' items');
              $('.Slide_cart_progress_bar').hide();
              $('.Slide_cart_announcment_message').hide();
              $('.Slide_cart_summary').hide();
              $('.Slide_cart_checkout_button__js').hide();
              $('.Checkout_button_reserve_message').hide();
              $('.cart-link__bubble').hide();
              console.log('Cart link should hidden');
            }
            else {
              $('.cart-link__bubble').show();
              $('.header-cart__count').show();
              $('.header-cart__count').text(cart.item_count);
              $('.header-cart__count').attr('data-bind',cart.item_count);
              $('.Slide_cart_empty_content').hide();
              $('.Slide_cart_upsells_title').show();
              $('.Slide_cart_upsells_slider').css('opacity', '1');
              $('.Slide_cart_icons').show();
              $('.Slide_cart_content_products').html(cart_item);
              $('.Slide_cart_title').find('span').text('• ' + cart.item_count + ' items');
              var discount_in_dollars = parseFloat(compare_price_total / 100) - parseFloat(total_price);
              if (discount_in_dollars > 0) {
                discount_in_dollars = discount_in_dollars.toFixed(2);
                compare_price_total = (compare_price_total / 100).toFixed(2);
                $('.Slide_cart_total_price').html(currency + total_price + '<s>' + currency + compare_price_total + '</s>');
                $('.Slide_cart_save_discount').html(currency + discount_in_dollars);
                $('.Slide_cart_summary_discount').show();
              }
              else {
                $('.Slide_cart_summary_discount').hide();
                compare_price_total = (compare_price_total / 100).toFixed(2);
                $('.Slide_cart_total_price').html(currency + total_price);
              }
              $('.Slide_cart_progress_bar').show();
              $('.Slide_cart_announcment_message').show();
              $('.Slide_cart_summary').show();
              $('.Slide_cart_checkout_button__js').show();
              $('.Checkout_button_reserve_message').show();
            }

             // Setting up environment with/without free gift
             var freeEmailGiftVariant = 7141462212666;
             var gift_in_cart = 0;
             for (var i = 0; i < cart.items.length; i++) {
               if (cart.items[i].product_id == freeEmailGiftVariant) {
                 gift_in_cart += cart.items[i].quantity;
               }
             }
 
             if (gift_in_cart == cart.item_count) {
              if (cart.item_count > 0){
                $('.Slide_cart_checkout_button__js').addClass('Disabled');
                $('.Checkout_button_info_message').show();
                $('.Checkout_button_reserve_message').hide();
              }
             }
             else {
              if (cart.item_count > 0){
                $('.Slide_cart_checkout_button__js').removeClass('Disabled');
                $('.Checkout_button_info_message').hide();
                $('.Checkout_button_reserve_message').show();
              }
             }

          });
          $('.Slide_cart_item_line').removeClass('Loading');
          $('.Slide_cart_upsells_container').removeClass('Loading');
        }, 1000);
      }

    //   Initiate cart load on web load
      buildCart();

    //   Slide cart controls
    $(document).on("click", ".Slide_cart_quantity_min__Js", function () {
        var currentId = $(this).attr('data-id');
        var currentQuantity = $(this).parent('.Slide_cart_quantity_container').find('.Slide_cart_quantity_value__Js').text();
        currentQuantity = parseFloat(currentQuantity);
        currentQuantity--;
    
        $(this).parent('.Slide_cart_quantity_container').parent('div').parent('.Slide_cart_item_line').addClass('Loading');
    
        var data = {
          "id": currentId,
          "quantity": currentQuantity
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log(data);
            buildCart();
          }
        });
      });
      $(document).on("click", ".Slide_cart_remove_item__js", function () {
        var currentId = $(this).attr('data-id');
        var data = {
          "id": currentId,
          "quantity": 0
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log(data);
            buildCart();
          }
        });
      });

      $(document).on("click", ".Slide_cart_bundle_remove_item__js", function () {
        $.ajax({
          type: 'POST',
          url: '/cart/clear.js',
          dataType: 'json',
          success: function(data) {
            // Do something on success (e.g., update UI)
            console.log('Cart is empty!');
          },
          error: function(xhr, textStatus, errorThrown) {
            // Do something on error
          }
        });
        buildCart();
      });
      
            
    
      $(document).on("click", ".Slide_cart_quantity_add__Js", function () {
        var currentId = $(this).attr('data-id');
        var currentQuantity = $(this).parent('.Slide_cart_quantity_container').find('.Slide_cart_quantity_value__Js').text();
        currentQuantity = parseFloat(currentQuantity);
        currentQuantity++;
    
        $(this).parent('.Slide_cart_quantity_container').parent('div').parent('.Slide_cart_item_line').addClass('Loading');
    
        var data = {
          "id": currentId,
          "quantity": currentQuantity
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log(data);
            buildCart();
          }
        });
      });

      $(document).on("click",".Slide_cart_upsell_atc",function() {
        if ($(this).hasClass('soldout')){

        }
        else{
          $(this).parent('div').parent('.Slide_cart_upsells_container').addClass('Loading');
          var currentId = $(this).attr('data-id');
          var currentQuantity = 1;
          var data = {
            "id": currentId,
            "quantity": currentQuantity
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log(data);
              buildCart();
            }
          });
        }
        
      });

      $('.Slide_cart_upsell_variant_select').change(function () {
        var currentId = $(this).val();
        // console.log(currentId);
        $(this).parent('div').parent('.Slide_cart_upsells_container').find('.Slide_cart_upsell_atc').attr('data-id', currentId);
        $('.Slide_cart_upsell_image_js').hide();
        $('.Slide_cart_upsell_price').hide();
        $('.Slide_cart_upsell_image_js').each(function () {
          if ($(this).attr('data-id') == currentId) {
            $(this).show();
          }
          $('.Slide_cart_upsell_price').each(function () {
            if ($(this).attr('data-id') == currentId) {
              $(this).show();
            }
          });
        });
      });
    
      $('.Slide_cart_checkout_button__js').click(function (evt) {

        document.cookie = "sale50Applied=disabled; expires=Thu, 1 Jan 2024 00:00:00 UTC; path=/";

        if ($(this).hasClass('Disabled')) {
          evt.preventDefault();
        }
        else {
          jQuery.getJSON('/cart.js', function (cart) {
            var upsell_in_cart = 0;
            var upsell_id = $('.Prepurchase_upsell_add_button').attr('data-id');
            for (var i = 0; i < cart.items.length; i++) {
              if(upsell_id == cart.items[i].id){
                upsell_in_cart += cart.items[i].quantity;
              }
            }
            console.log(upsell_in_cart);
            var upsell_visible = $('.Prepurchase_upsell_overlay').attr('data');
            if (upsell_visible == 'visible'){
                $('.Slide_cart_checkout_button__js').text('LOADING...');
                $('.Prepurchase_upsell_overlay').css('display', 'flex');
                startUpsellCountdown();
                // $('.Slide_cart_checkout_button__js').text('LOADING...');
                // window.location="/checkout";
            }
            else{
              $('.Slide_cart_checkout_button__js').text('LOADING...');
              window.location="/checkout";
            }
          });
        }
      });
    
      $('.Cart_upsell_add_to_cart_btn').click(function () {
        var currentVariantId = $(this).attr('data-id');
        var data = {
          "id": currentVariantId,
          "quantity": 1
        }
    
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function () {
            // window.location = '/checkout';
            $('.Whole_cart_popup').css('opacity', '0');
            setTimeout(function () {
              $('.Whole_cart_popup').hide();
            }, 200);
            buildCart();
            RechargeCartSubmit();
          }
        });
      });
    
      $('.Cart_upsell_decline_offer_message').click(function () {
        $('.Whole_cart_popup').css('opacity', '0');
        setTimeout(function () {
          $('.Whole_cart_popup').hide();
        }, 200);
        // window.location = '/checkout';
        RechargeCartSubmit();
    
      });


      $('.Slide_cart_close_button').click(function () {
        $('.Slide_cart_whole').css('right', '-600px');
        $('.Slide_cart_overlay').hide();
        $('#reamaze-widget').show();
      });
    
      $('.Slide_cart_overlay').click(function () {
        $('.Slide_cart_whole').css('right', '-600px');
        $('.Slide_cart_overlay').hide();
        $('#reamaze-widget').show();
      });
    
    
      $('.js-drawer-open-cart').click(function (evt) {
        evt.preventDefault();
        $('.Slide_cart_whole').css('right', '0px');
        $('.Slide_cart_overlay').show();
        $('#reamaze-widget').hide();
      });


    
    
      $(document).on("click",".collection_quick_add_button",function(evt) {
        $(this).text('ADDING TO CART...');
          evt.preventDefault();
          var currentQty = 1;
          
            var currentId = $(this).parent('form').find('.Collection_form_variant_id_js').val();
            var data = {
              "id": currentId,
              "quantity": currentQty
            }
      
          console.log(data);
      
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log(data);
              buildCart();
            }
          });
      
          setTimeout(function () {
            $('.Slide_cart_whole').css('right', '0px');
            $('.Slide_cart_overlay').show();
            $('.collection_quick_add_button').text('ADD TO CART →');
            $('#reamaze-widget').hide();
          }, 1000);
        });


        $('.add-to-cart').click(function(){
          $('.Slide_cart_progress_bar').hide();
          $('.Slide_cart_progress_bar').addClass('Hidden_load');
          $('.Slide_cart_loading_animation_content').show();
          $('.Slide_cart_content_products').hide();
          $('.Slide_cart_announcment_message').hide();
          $('.Slide_cart_announcment_message').addClass('Hidden_load')
            setTimeout(function(){
              buildCart();
              $('.Slide_cart_empty_content').hide();
              $('.Slide_cart_whole').css('right', '0px');
              $('.Slide_cart_overlay').show();
              $('.collection_quick_add_button').text('ADD TO CART →');
            },1000);
            setTimeout(function(){
              $('.Slide_cart_progress_bar').show();
              $('.Slide_cart_progress_bar').removeClass('Hidden_load')
              $('.Slide_cart_loading_animation_content').hide();
              $('.Slide_cart_content_products').show();
              $('.Slide_cart_announcment_message').show();
              $('.Slide_cart_announcment_message').removeClass('Hidden_load')
            },3000);
        });


        // Sticky atc
        $('.Sticky_atc_button').click(function(){

          $('.Slide_cart_progress_bar').hide();
          $('.Slide_cart_progress_bar').addClass('Hidden_load');
          $('.Slide_cart_loading_animation_content').show();
          $('.Slide_cart_content_products').hide();
          $('.Slide_cart_announcment_message').hide();
          $('.Slide_cart_announcment_message').addClass('Hidden_load')

          var currentId = $('.product-single__variants').val();
          console.log(currentId, 'CURRENT ID');
          data = {
            "id": currentId,
            "quantity": 1
          }

          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              buildCart();
              $('.Slide_cart_empty_content').hide();
              $('.Slide_cart_whole').css('right', '0px');
              $('.Slide_cart_overlay').show();
              setTimeout(function(){
                $('.Slide_cart_progress_bar').show();
                $('.Slide_cart_progress_bar').removeClass('Hidden_load')
                $('.Slide_cart_loading_animation_content').hide();
                $('.Slide_cart_content_products').show();
                $('.Slide_cart_announcment_message').show();
                $('.Slide_cart_announcment_message').removeClass('Hidden_load')
              },3000);
            }
          });
          
        });


        // Upsell add to cart
        $('.Product_section_upsell_atc_button__js').click(function(){
          var currentId  = $(this).attr('data-id');
          var currentQty = 1;
          var data = {
            "id": currentId,
            "quantity": currentQty
          }

          $('.Slide_cart_progress_bar').hide();
          $('.Slide_cart_progress_bar').addClass('Hidden_load');
          $('.Slide_cart_loading_animation_content').show();
          $('.Slide_cart_content_products').hide();
          $('.Slide_cart_announcment_message').hide();
          $('.Slide_cart_announcment_message').addClass('Hidden_load');
          $('.Product_section_upsell_atc_button__js').text('LOADING...');
      
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log(data);
                buildCart();
                  $('.Slide_cart_empty_content').hide();
                  $('.Slide_cart_whole').css('right', '0px');
                  $('.Slide_cart_overlay').show();
                setTimeout(function(){
                  $('.Slide_cart_progress_bar').show();
                  $('.Slide_cart_progress_bar').removeClass('Hidden_load')
                  $('.Slide_cart_loading_animation_content').hide();
                  $('.Slide_cart_content_products').show();
                  $('.Slide_cart_announcment_message').show();
                  $('.Slide_cart_announcment_message').removeClass('Hidden_load');
                  $('.Product_section_upsell_atc_button__js').text('ADD');
                },3000);
            }
          });
        });


        // Bundles add to cart
        $('.Bundle_product_atc_button').click(function(){
          if ($(this).hasClass('Soldout')){

          }
          else{
            $('.Bundle_product_atc_button').text('ADDING');
            var currentQty = 1;
            var items = [];
            $('.Bundle_product_image__js.active').each(function(){
              var currentId = $(this).attr('data-id');
              items.push({ id: currentId, quantity: currentQty });
            });

            console.log(items);

            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: {
                items: items,
              },
              dataType: "json",
              success: function (data) {
                // Do something on success
                console.log(data);
                setTimeout(function(){
                  buildCart();
                  $('.Slide_cart_empty_content').hide();
                  $('.Slide_cart_whole').css('right', '0px');
                  $('.Slide_cart_overlay').show();
                  $('.Bundle_product_atc_button').text('ADD BUNDLE TO CART');
                },1000);
                setTimeout(function(){
                  $('.Slide_cart_progress_bar').show();
                  $('.Slide_cart_progress_bar').removeClass('Hidden_load')
                  $('.Slide_cart_loading_animation_content').hide();
                  $('.Slide_cart_content_products').show();
                  $('.Slide_cart_announcment_message').show();
                  $('.Slide_cart_announcment_message').removeClass('Hidden_load')
                },3000);;
              },
            });
          }
        });

        // Upsell variants
        $("body").on('change', '.Slide_cart_upsell_selector__js', function(){
          var currentId = $(this).val();
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Slide_cart_upsell_price').hide();
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Slide_cart_upsell_price').each(function(){
            if ($(this).attr('data-id') == currentId){
              $(this).show();
            }
          });
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.sale').hide();
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.sale').each(function(){
            if ($(this).attr('data-id') == currentId){
              $(this).show();
            }
          });
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Upsell_item_image').hide();
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Upsell_item_image').each(function(){
            if ($(this).attr('data-id') == currentId){
              $(this).show();
            }
          });
          $(this).parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Slide_cart_upsell_atc').attr('data-id', currentId);
        });

          // Set the timer duration (1 hour = 60 minutes)
          var duration = 60 * 60; // 1 hour in seconds
          
          // Get the HTML element where you want to display the countdown
          var countdownElement = $('.Slide_cart_timer__js');
          
          // Function to format the time in HH:MM:SS format
          function formatTime(seconds) {
            // var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor((seconds % 3600) / 60);
            var remainingSeconds = seconds % 60;
            
            return minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0');
          }
          
          // Function to update the countdown every second
          function updateCountdown() {
            countdownElement.text(formatTime(duration));
            
            if (duration > 0) {
              duration--;
              setTimeout(updateCountdown, 1000);
            }
          }
          
          // Start the countdown
          updateCountdown();
        

          $('.Prepurchase_upsell_deline').click(function(){
            $('.Prepurchase_upsell_deline').text('Loading...');
            window.location.href = '/checkout';
          });

          $('.Prepurchase_upsell_close_button').click(function(){
            $('.Prepurchase_upsell_overlay').hide();
            window.location.href = '/checkout';
          });

          
          $('.Slide_cart_option_selection').change(function(){
            var currentTitle = '';
            $(this).parent('div').parent('.Slide_cart_options_container').find('.Slide_cart_option_selection').each(function(){
              var value = $(this).val();
              currentTitle = currentTitle + '-' + value;
            });
            currentTitle = currentTitle.substring(1);
            console.log(currentTitle, 'CURRENT');
            var currentId = '';
            var currentInv;
            $('.Upsell_product_variant_selector__js_input').each(function(){
              if ($(this).attr('data-title') == currentTitle){
                currentId = $(this).attr('data-id');
                currentInv = $(this).attr('data-inventory');
              }
            });

            $(this).parent('div').parent('.Slide_cart_options_container').parent('.Slide_cart_upsell_addons').parent('div').parent('.Slide_cart_upsells_container').find('.Upsell_item_image').hide();
            $(this).parent('div').parent('.Slide_cart_options_container').parent('.Slide_cart_upsell_addons').parent('div').parent('div').find('.Upsell_item_image').each(function(){
              if ($(this).attr('data-id') == currentId){
                $(this).show();
              }
            });
          console.log(currentId, 'CURRENT ID');
            $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').attr('data-id', currentId);
            $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').attr('data-inventory', currentInv);
            if (currentInv > 0){
              $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').text('+ ADD');
              $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').removeClass('soldout');
            }
            else{
              $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').text('SOLD OUT');
              $(this).parent('div').parent('div').parent('div').parent('div').parent('div').find('.Slide_cart_upsell_atc').addClass('soldout');
            }
          });


          $('.Prepurchase_upsell_add_button').click(function(){
            var currentId = $(this).attr('data-id');
            var data = {
              "id": currentId,
              "quantity": 1
            }
        
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function () {
                console.log(data);
              }
            });
            $('.Prepurchase_upsell_add_button').text('Loading...');
            window.location.href = '/checkout';
          });

          $('.Prepurchase_upsell_variants select').change(function(){
            var currentId = $(this).val();
            $('.Prepurchase_upsell_add_button').attr('data-id', currentId);

            $('.Prepurchase_upsell_pricing').hide();
            $('.Prepurchase_upsell_pricing').each(function(){
              if($(this).attr('data-id') == currentId){
                $(this).css('display', 'flex');
              }
            });
          });

          function startUpsellCountdown(){
            var timerContainer = $(".Prepurchase_timer_js");
            var minutesContainer = timerContainer.find(".minutes");
            var secondsContainer = timerContainer.find(".seconds");

            var minutes = parseInt(minutesContainer.text());
            var seconds = parseInt(secondsContainer.text());

            var countdown = setInterval(function() {
                if (minutes == 0 && seconds == 0) {
                    clearInterval(countdown);
                    alert("Time's up!");
                } else {
                    if (seconds == 0) {
                        minutes--;
                        seconds = 59;
                    } else {
                        seconds--;
                    }

                    // Update the timer display
                    minutesContainer.text(minutes < 10 ? "0" + minutes : minutes);
                    secondsContainer.text(seconds < 10 ? "0" + seconds : seconds);
                }
            }, 1000);
          }

    
});